module.exports = __webpack_public_path__ + "static/img/jp_bgc.44961fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/jp_bgc.png
// module id = dNHP
// module chunks = 6